MemberMiniProfileView = require 'views/member-menu-profile/member-mini-profile-view'

module.exports = class ActivityMemberMenuView extends MemberMiniProfileView
  renderMenu: -> return



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/activity-member-menu-view.coffee